import { render } from "./UserEditTableItem.vue?vue&type=template&id=72d3353a&scoped=true&ts=true"
import script from "./UserEditTableItem.vue?vue&type=script&lang=ts"
export * from "./UserEditTableItem.vue?vue&type=script&lang=ts"

import "./UserEditTableItem.vue?vue&type=style&index=0&id=72d3353a&scoped=true&lang=scss"

import exportComponent from "C:\\Users\\y-tosa.LOCALPSC\\repo\\seto-solan\\apps\\admin-app\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-72d3353a"]])

export default __exports__